// extracted by mini-css-extract-plugin
export default {"btn":"AdditionalDriverInfo_btn__6649m","darkBtn":"AdditionalDriverInfo_darkBtn__Dw4ah","borderLightBtn":"AdditionalDriverInfo_borderLightBtn__eDUYD"};